/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { WidgetDefinition } from "@insite/client-framework/Types/ContentItemDefinitions";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDetailsPageContext } from "@insite/content-library/Pages/ProductDetailsPage";
import React from "react";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsBrandStyles {
    brandStyles?: ProductBrandStyles;
}

export const productDetailsBrandStyles: ProductDetailsBrandStyles = {};

const styles = productDetailsBrandStyles;

const ProductDetailsBrandWidget: React.FC<Props> = ({ product }) => {
    if (!product.brand) {
        return null;
    }

    return <ProductBrand brand={product.brand} showLogo={true} extendedStyles={styles.brandStyles} />;
};

export const definition: WidgetDefinition = {
    displayName: "Product Details Brand",
    group: "Product Details",
    allowedContexts: [ProductDetailsPageContext],
    fieldDefinitions: [],
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsBrandWidget),
    definition,
};

export default widgetModule;
